<div class="modal-header">
    <div class="row" style="width: 100%;">
        <div class="col-12 text-center">
            <h6 class="m-0">Tracking</h6>
        </div>
        <div class="col">
            <div class="row no-gutters" style="align-items: center;">
                <div class="col-1">
                    <img *ngIf="Detail.UserImage != null && Detail.UserImage != ''" mat-card-image class="userImage"
                        [src]="common.PhotoLink(Detail.UserImage)" />
                    <div *ngIf="Detail.UserImage == null || Detail.UserImage == ''" class="initial-image">
                        <div class="image">
                            {{common.getInitial(Detail.EmployeeName)}}
                        </div>
                    </div>
                </div>
                <div class="col-10">
                    <span class="text-label">{{Detail.EmployeeName}}</span><br />
                    <span class="text-label-light">#{{Detail.EmpCode}}</span><br />
                    <span class="text-label-light">{{Detail.DesignationName}}</span>
                </div>
            </div>
        </div>
        <div class="col-auto">
            <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="row">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th>ApprovalStage</th>
                    <th>ApproverName</th>
                    <th>Status</th>
                    <th>ActionDate</th>
                    <th>Remark</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let TableData of TableDatas; let i = index">
                    <th scope="row" style="width: 5px;">{{TableData['SrNo.']}}</th>
                    <td>{{TableData['ApprovalStage']}}</td>
                    <td>{{TableData['ApproverName']}}</td>
                    <td><span class="badge"
                            [ngClass]="{'success': (TableData['Status'] | lowercase) == 'approved', 'danger':(TableData['Status'] | lowercase) == 'rejected','warning':(TableData['Status'] | lowercase) == 'pending' || (TableData['Status'] | lowercase) == 'reInitiated'}">{{TableData['Status']}}</span>
                    </td>
                    <td>{{TableData['ActionDate']}}</td>
                    <td>{{TableData['Remark']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" [disabled]="isDisabled" (click)="close()"><i class="bi bi-x"
            *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>